module.exports = __webpack_public_path__ + "assets/img/img_bj3.0db821f7.png";